import React, { useState } from "react";
import { PhoneIcon, ChatIcon } from "@heroicons/react/outline";
import { InView } from "react-intersection-observer";
import Swal from "sweetalert2";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    requestPoster: false,
  });

  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("http://194.164.148.244:4061/api/users/contactwithus", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        // Show SweetAlert popup
        Swal.fire({
          icon: "success",
          title: "Thank You!",
          text: data.message || "Your message has been sent. We’ll get back to you shortly.",
          confirmButtonColor: "#3B82F6",
        });

        // Reset form
        setFormData({
          name: "",
          email: "",
          message: "",
          requestPoster: false,
        });

        setErrorMessage("");
      } else {
        throw new Error(data.message || "Something went wrong!");
      }
    } catch (error) {
      console.error("Submission Error:", error);
      setErrorMessage(error.message);
    }
  };

  return (
    <div className="bg-white py-8">
      <div className="container mx-auto px-6 flex flex-col lg:flex-row items-start">
        {/* Left Section - Contact Info */}
        <InView triggerOnce={true} threshold={0.5}>
          {({ inView, ref }) => (
            <div
              ref={ref}
              className={`w-full lg:w-2/5 text-left mb-8 lg:mb-0 ${
                inView ? "animate__animated animate__fadeInLeft" : ""
              }`}
            >
              <h2 className="text-3xl font-bold text-gray-800 mb-4">
                Quick Support
              </h2>
              <p className="text-lg text-gray-600 mb-6">
                Get in touch with us!
              </p>
              <div className="flex flex-col space-y-6 lg:space-y-0 lg:flex-row lg:space-x-6 mb-6">
                <div className="flex flex-col items-start">
                  <PhoneIcon className="w-6 h-6 text-blue-500 mb-2" />
                  <p className="text-lg text-gray-700">Call Us:</p>
                  <p className="text-lg text-gray-700 font-semibold">
                    +91 984 900 8143
                  </p>
                </div>
                <div className="flex flex-col items-start">
                  <ChatIcon className="w-6 h-6 text-blue-500 mb-2" />
                  <p className="text-lg text-gray-700">Chat with Us</p>
                  <p className="text-lg text-gray-700">
                    Our support team is available from 9 am to 5 pm.
                  </p>
                  <p className="text-lg text-gray-700">
                    businessbadavo@gmail.com
                  </p>
                </div>
              </div>
            </div>
          )}
        </InView>

        {/* Right Section - Contact Form */}
        <InView triggerOnce={true} threshold={0.5}>
          {({ inView, ref }) => (
            <div
              ref={ref}
              className={`w-full lg:w-3/5 shadow-lg p-6 bg-white rounded-lg mt-6 lg:mt-0 ${
                inView ? "animate__animated animate__fadeInRight" : ""
              }`}
            >
              <h2 className="text-3xl font-bold text-gray-800 mb-6">
                Fill out the form, and we’ll get back to you as soon as possible.
              </h2>
              <form onSubmit={handleSubmit}>
                <div className="mb-4">
                  <label className="block text-gray-700 font-semibold">
                    Your Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full p-3 border border-gray-300 rounded-lg"
                    required
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-gray-700 font-semibold">
                    Your Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full p-3 border border-gray-300 rounded-lg"
                    required
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-gray-700 font-semibold">
                    Message
                  </label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="w-full p-3 border border-gray-300 rounded-lg"
                    required
                  />
                </div>
                <div className="mb-4 flex items-center">
                  <input
                    type="checkbox"
                    name="requestPoster"
                    checked={formData.requestPoster}
                    onChange={handleChange}
                    className="mr-2"
                  />
                  <span className="text-gray-700">
                    Yes, I would like to request a poster.
                  </span>
                </div>
                {errorMessage && (
                  <p className="text-red-500 mb-4">{errorMessage}</p>
                )}
                <button
                  type="submit"
                  className="w-auto bg-blue-500 text-white font-semibold py-2 px-6 rounded-lg float-right"
                >
                  Submit
                </button>
              </form>
            </div>
          )}
        </InView>
      </div>
    </div>
  );
};

export default ContactUs;
